import {useState}  from 'react';
import {toast} from 'react-toastify';
import { useDispatch } from 'react-redux';
import { retweetPost } from './redux/chatSlice';
function Retweet({closeModal,Post}){
const [ShowReTweetDialog,setShowReTweetDialog]=useState(true);
const [text,setText]=useState('');
const dispatch = useDispatch();

//access to open the hidden file  
const handlepost=async()=>{
if(!text ){
   alert(<h4>'Write Something'</h4>);
   return;
}
dispatch(retweetPost({
   id:Post,
   text:text
}));
toast.success('Retweet posted successfully');
setText('');
closeModal();
};
/*try{
({
id:Post,
comment:text
}));
await axios.post('http://posttweet');
    toast.success('Tweet posted successfully');
   //reset
setText('');
    }catch(err){
      console.log('err');
    toast.error('Tweet Failed');
    };
   };*/
    return(
        <div>
            {ShowReTweetDialog && (
   <div  className='overlay'>
   <div  className='glass-pop'>
         <div className='parent'style={{padding:'20px',width:'100%' }}>
   <span className='tweet-modal'style={{fontFamily:'helvetica',fontSize:'25px'}} >Tweet your reply</span><span onClick={closeModal} style={{paddingLeft:'24%',fontSize:'25px' }}>X</span>
      <div className='tweetdialog2'style={{padding:'20px',width:'70%' }}>
      <hr></hr>
   <textarea type='text'placeholder='Reminds me of'style={{padding:'17px',outline:'none',border:'4px solid lightblue',width:'100%' }} value={text} onChange={(e)=>setText(e.target.value)}></textarea>
    <hr></hr>
   </div>
</div>
   <div className='d-flex' style={{paddingLeft:'400px' ,width:'100%',margin:'10px',gap:'20px'}}>
   <button className='btn btn-primary'  onClick={handlepost}>post</button>
   <button className='btn btn-warning' onClick={closeModal}>close</button>
   </div>
</div>
</div>

)}
        </div>
    )
}
export default Retweet;